var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3332C10 9.64984 12.9833 6.6665 16.6667 6.6665C20.35 6.6665 23.3333 9.64984 23.3333 13.3332C23.3333 17.0165 20.35 19.9998 16.6667 19.9998C12.9833 19.9998 10 17.0165 10 13.3332ZM20 30.3332C20 28.7332 20.8333 27.2332 22 26.2332V24.1665C22 24.0832 22.0333 23.9832 22.0333 23.8998C20.3833 23.5332 18.5833 23.3332 16.6667 23.3332C9.3 23.3332 3.33334 26.3165 3.33334 29.9998V33.3332H20V30.3332ZM36.6667 30.4998V36.3332C36.6667 37.3332 35.6667 38.3332 34.5 38.3332H25.3333C24.3333 38.3332 23.3333 37.3332 23.3333 36.1665V30.3332C23.3333 29.3332 24.3333 28.3332 25.3333 28.3332V24.1665C25.3333 21.8332 27.6667 19.9998 30 19.9998C32.3333 19.9998 34.6667 21.8332 34.6667 24.1665V24.9998H32.5V24.1665C32.5 22.8332 31.3333 21.9998 30 21.9998C28.6667 21.9998 27.5 22.8332 27.5 24.1665V28.3332H34.6667C35.6667 28.3332 36.6667 29.3332 36.6667 30.4998Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveUsersIcon);
export default __webpack_public_path__ + "static/media/InactiveUsersIcon.5efbd5b5.svg";
export { ForwardRef as ReactComponent };